export default "__VITE_ASSET__1edf4047__"